import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentPageElementVisibilityRule = _resolveComponent("ContentPageElementVisibilityRule")!

  return (_openBlock(), _createBlock(_component_ContentPageElementVisibilityRule, {
    ref: "elementVisibilityRule",
    "row-id": this.rowId,
    "cb-in-row-id": this.cbInRowId,
    onSaved: _cache[0] || (_cache[0] = ($event: any) => (this.$emit('saved')))
  }, null, 8, ["row-id", "cb-in-row-id"]))
}